<template>
  <div class="main-content">
    <div class="search-panel">
      <div class="keyword-search">
        <el-row class="filter-component__label">搜索关键字</el-row>
        <el-row>
          <el-input v-model="queryData.searchKey" clearable placeholder="请输入行业、职位、公司或学校等关键字"
            @keyup.enter.native="onSearch"></el-input>
        </el-row>
      </div>
      <div class="search-filter-simple__component">
        <el-row class="filter-component__label">是否悬赏</el-row>
        <el-row>
          <el-radio-group v-model="queryData.resumeType">
            <el-radio-button v-for="(item) in resumeTypeList" :key="item.id" :label="item.id">{{item.text}}
            </el-radio-button>
          </el-radio-group>
        </el-row>
      </div>
      <el-collapse-transition>
        <div class="search-more" v-show="showMore">
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">意向工作地</el-row>
            <el-row>
              <el-cascader ref="casCity" v-model="cityIds" popper-class="city-cascader" :options="cityList"
                :props="cityProps" collapse-tags :show-all-levels="false" clearable @change="onCityChange">
                <template slot-scope="{ data }">
                  <span>{{ data.text }}</span>
                </template>
              </el-cascader>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">求职意向</el-row>
            <el-row>
              <el-cascader ref="casPosition" v-model="positionIds" popper-class="city-cascader" :options="positionList"
                :props="positionProps" collapse-tags :show-all-levels="false" clearable>
                <template slot-scope="{ data }">
                  <span>{{ data.text }}</span>
                </template>
              </el-cascader>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">学历要求</el-row>
            <el-row>
              <el-col :span="11">
                <el-select v-model="minDegree" placeholder="请选择" @change="onChangeMinDegree">
                  <el-option v-for="item in minDegreeList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="connect-minus">-</el-col>
              <el-col :span="11">
                <el-select v-model="maxDegree" placeholder="请选择">
                  <el-option v-for="item in maxDegreeList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">工作年限</el-row>
            <el-row>
              <el-col :span="11">
                <el-select v-model="minWorkYear" placeholder="请选择" @change="onChangeMinWorkYear">
                  <el-option v-for="item in minWorkYearList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="connect-minus">-</el-col>
              <el-col :span="11">
                <el-select v-model="maxWorkYear" placeholder="请选择">
                  <el-option v-for="item in maxWorkYearList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">月薪范围</el-row>
            <el-row>
              <el-col :span="11">
                <el-select v-model="minSalary" placeholder="请选择" @change="onChangeMinSalary">
                  <el-option v-for="item in minSalaryList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="connect-minus">-</el-col>
              <el-col :span="11">
                <el-select v-model="maxSalary" placeholder="请选择">
                  <el-option v-for="item in maxSalaryList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">年龄</el-row>
            <el-row>
              <el-col :span="11">
                <el-select v-model="minAge" placeholder="请选择" @change="onChangeMinAge">
                  <el-option v-for="item in minAgeList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" class="connect-minus">-</el-col>
              <el-col :span="11">
                <el-select v-model="maxAge" placeholder="请选择">
                  <el-option v-for="item in maxAgeList" :key="item.id" :label="item.text" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">性别</el-row>
            <el-row>
              <el-select v-model="queryData.sex" placeholder="请选择">
                <el-option v-for="item in sexList" :key="item.id" :label="item.text" :value="item.id">
                </el-option>
              </el-select>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">简历更新时间</el-row>
            <el-row>
              <el-select v-model="queryData.resumeRefresh" placeholder="请选择">
                <el-option v-for="item in resumeRefreshList" :key="item.id" :label="item.text" :value="item.id">
                </el-option>
              </el-select>
            </el-row>
          </div>
          <div class="search-filter-simple__component">
            <el-row class="filter-component__label">行业</el-row>
            <el-row>
              <el-select v-model="queryData.industryId" placeholder="请选择">
                <el-option v-for="item in industryList" :key="item.id" :label="item.text" :value="item.id">
                </el-option>
              </el-select>
            </el-row>
          </div>
        </div>
      </el-collapse-transition>
    </div>
    <div class="talent-search__button">
      <el-button type="primary" style="padding: 10px 39px;" icon="el-icon-search" @click="onSearch">搜索</el-button>
      <el-button style="margin-left:24px;" type="text" icon="el-icon-s-operation" @click="showMore = !showMore">更多搜索条件
      </el-button>
      <el-button style="margin-left:24px;" type="text" icon="el-icon-brush" class="icoRotate180" @click="onClear">清空搜索条件
      </el-button>
    </div>
    <div class="talent-search__candition">
      <div class="divider"></div>
      <span style="display: inline-block; margin-top:12px; font-size: 14px;">搜索条件：</span>
      <el-tag v-for="query in queryDict" :key="query.key" size="medium" closable @close="onCloseTag(query.key)">
        <span class="tag-key">{{query.keyText}}：</span>{{query.valueText}}
      </el-tag>
    </div>
    <el-row class="search-pagination" :class="isfixed ? 'fixed-page':''">
      <el-pagination background @current-change="handleCurrentChange" :current-page="queryData.currentPage"
        :page-sizes="[10]" :page-size="queryData.pageSize" layout="slot, prev, pager, next" :total="total">
        <span class="el-pagination__total">共 {{realTotal > 10000 ? "10000+" : realTotal}}
          条记录（用时：{{(time / 1000).toFixed(2)}} 秒）</span>
      </el-pagination>
    </el-row>
    <div v-loading="loading" style="margin-bottom: 40px;">
      <div v-for="talent in talents" :key="talent.meDataId">
        <taCard :talent="talent" :words="keywords" @goto="onGoto(talent)"></taCard>
      </div>
    </div>
  </div>
</template>

<script>
  import cityList from '~/static/hotCitys';
  import positionList from '~/static/sysPositions';
  import {
    getSplitWords
  } from '~/api/common';
  import {
    resumeTypeOption,
    degreeOption,
    sexOption,
    resumeRefreshOption,
    industryOption
  } from '~/static/commonData';
  import {
    fullTextSearch
  } from '~/api/resume';
  import taCard from './comp_card_long';
  export default {
    components: {
      taCard,
    },
    data() {
      return {
        cityList: cityList.data,
        cityProps: {
          value: 'value',
          label: 'label',
          children: 'children',
        },
        positionList: positionList.data,
        positionProps: {
          value: 'value',
          label: 'label',
          children: 'children',
          multiple: true
        },
        resumeTypeList: [],
        sexList: [],
        minDegreeList: [],
        maxDegreeList: [],
        minWorkYearList: [],
        maxWorkYearList: [],
        minSalaryList: [],
        maxSalaryList: [],
        minAgeList: [],
        maxAgeList: [],
        resumeRefreshList: [],
        industryList: [],

        minDegree: 0,
        maxDegree: 0,
        minWorkYear: -1,
        maxWorkYear: -1,
        minSalary: 0,
        maxSalary: 0,
        minAge: 0,
        maxAge: 0,
        cityIds: [],
        cityId: 0,
        positionIds: [],
        queryData: {
          currentPage: 1,
          pageSize: 10,

          searchKey: '',
          resumeType: 0,
          city: '',
          position: '',
          sex: 0,
          resumeRefresh: 0,
          industryId: 0,
        },
        talents: [],
        total: 0,
        realTotal: 0,
        isfixed: false,
        loading: false,
        time: 0,
        routeText: '',
        showMore: false,
        queryDict: [],
        keywords: [],
      };
    },
    computed: {
      positionId(){
        var ids = [];
        if(this.positionIds){
          this.positionIds.forEach(id => {
            if(id && id.length == 2){
              ids.push(id[1]);
            }
          });
        }
        return ids;
      },
      positionName(){
        var names = [];
        if(this.positionIds){
          this.positionIds.forEach(id => {
            if(id && id.length == 2){
              var positionId = id[1];
              this.positionList.forEach(c => {
                if (c.children) {
                  c.children.forEach(cc => {
                    if (cc.value == positionId) {
                      names.push(cc.label);
                    }
                  });
                }
              });
            }
          });
        }
        return names.toString();
      },
    },
    created() {
      this.initPageData();
      this.onClear();
      this.getTalentList();
      this.$emit('changeMenu', 'TalentSearch');
    },
    // activated() {
    //   this.initPageData();
    //   this.onClear();
    //   this.getTalentList();
    // },
    mounted() {
      window.addEventListener('scroll', this.handlePageFix, true);
    },
    beforeRouteLeave(to, from, next) {
      window.removeEventListener('scroll', this.handlePageFix, true);
      next();
    },
    methods: {
      initPageData() {
        this.resumeTypeList = [{
          text: '不限',
          id: 0
        }];
        resumeTypeOption.forEach(item => {
          this.resumeTypeList.push({
            text: item.text,
            id: item.id
          });
        });

        this.sexList = [{
          text: '不限',
          id: 0
        }];
        sexOption.forEach(item => {
          this.sexList.push({
            text: item.text,
            id: item.id
          });
        });

        this.minDegreeList = [{
          text: '不限',
          id: 0
        }];
        degreeOption.forEach(item => {
          this.minDegreeList.push({
            text: item.text,
            id: item.id
          });
        });
        this.maxDegreeList = [{
          text: '不限',
          id: 0
        }];

        this.minWorkYearList = [{
          text: '不限',
          id: -1
        }];
        this.minWorkYearList.push({
          text: '无经验',
          id: 0
        });
        for (let i = 1; i <= 30; i++) {
          this.minWorkYearList.push({
            text: i + '年',
            id: i
          });
        }

        this.maxWorkYearList = [{
          text: '不限',
          id: -1
        }];

        this.minSalaryList = [{
          text: '不限',
          id: 0
        }];
        for (let i = 1; i <= 45; i++) {
          this.minSalaryList.push({
            text: i + 'K',
            id: i
          });
        }

        this.maxSalaryList = [{
          text: '不限',
          id: 0
        }];

        this.minAgeList = [{
          text: '不限',
          id: 0
        }];
        for (let i = 18; i <= 59; i++) {
          this.minAgeList.push({
            text: i + '岁',
            id: i
          });
        }
        this.maxAgeList = [{
          text: '不限',
          id: 0
        }];

        this.resumeRefreshList = [{
          text: '不限',
          id: 0
        }];
        resumeRefreshOption.forEach(item => {
          this.resumeRefreshList.push({
            text: item.text,
            id: item.id
          });
        });

        this.industryList = [{
          text: '不限',
          id: 0
        }];
        industryOption.forEach(item => {
          this.industryList.push({
            text: item.text,
            id: item.id
          });
        });
      },
      onChangeMinDegree(val) {
        if (val === 0) {
          this.maxDegreeList = [{
            text: '不限',
            id: 0
          }];
          this.maxDegree = 0;
          return;
        }
        this.maxDegreeList = [{
          text: '及以上',
          id: 0
        }];
        this.maxDegree = 0;
        degreeOption.forEach(item => {
          if (item.id >= val) {
            this.maxDegreeList.push({
              text: item.text,
              id: item.id
            });
          }
        });
      },
      onChangeMinWorkYear(val) {
        if (val === -1) {
          this.maxWorkYearList = [{
            text: '不限',
            id: -1
          }];
          this.maxWorkYear = -1;
          return;
        }
        this.maxWorkYearList = [{
          text: '及以上',
          id: -1
        }];
        if (val <= 0) {
          this.maxWorkYearList.push({
            text: '无经验',
            id: 0
          });
          for (let i = 1; i <= 30; i++) {
            this.maxWorkYearList.push({
              text: i + '年',
              id: i
            });
          }
        } else {
          for (let i = val; i <= 30; i++) {
            this.maxWorkYearList.push({
              text: i + '年',
              id: i
            });
          }
        }
        if (this.maxWorkYearList && this.maxWorkYearList[0]) {
          this.maxWorkYear = this.maxWorkYearList[0].id;
        }
      },
      onChangeMinSalary(val) {
        this.maxSalaryList = [{
          text: '不限',
          id: 0
        }];
        this.maxSalary = 0;
        if (val <= 0) {
          for (let i = 1; i <= 50; i++) {
            this.maxSalaryList.push({
              text: i + 'K',
              id: i
            });
          }
        } else {
          for (var i = val; i <= 50; i++) {
            this.maxSalaryList.push({
              text: i + 'K',
              id: i
            });
          }
        }
      },
      onChangeMinAge(val) {
        this.maxAgeList = [{
          text: '不限',
          id: 0
        }];
        this.maxAge = 0;
        if (val < 17) {
          for (let i = 18; i <= 60; i++) {
            this.maxAgeList.push({
              text: i + '岁',
              id: i
            });
          }
        } else {
          for (var i = val; i <= 60; i++) {
            this.maxAgeList.push({
              text: i + '岁',
              id: i
            });
          }
        }
      },
      handlePageFix() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var elItem = document.querySelector('.talent-search__candition');
        var offsetTop = elItem.offsetTop + elItem.clientHeight;
        scrollTop > offsetTop ? this.isfixed = true : this.isfixed = false;
      },
      getTalentList() {
        this.loading = true;
        var params = {
          searchKey: this.queryData.searchKey,
          resumeType: this.queryData.resumeType,
          expectCity: this.queryData.city === '' ? '' : this.queryData.city,
          sexId: this.queryData.sex,
          expectPostId: this.positionId,
          minAge: this.minAge,
          maxAge: this.maxAge,
          expectMinSalary: this.minSalary,
          expectMaxSalary: this.maxSalary,
          minDegreeId: this.minDegree,
          maxDegreeId: this.maxDegree,
          minWorkYear: this.minWorkYear,
          maxWorkYear: this.maxWorkYear,
          resumeRefreshTimeId: this.queryData.resumeRefresh,
          industryId: this.queryData.industryId,
          pageIndex: this.queryData.currentPage - 1,
          pageSize: this.queryData.pageSize,
        };
        this.buildQueryDict();
        fullTextSearch(params).then((r) => {
          if (r.errcode == 0) {
            var data = r.data;
            this.talents = data.list;
            this.realTotal = data.total_item_count;
            this.total = this.realTotal > 1000 ? 1000 : this.realTotal;
            this.time = data.flag;
          } else {
            this.$message.error('获取人才列表出错，原因：' + r.errmsg);
          }
          this.loading = false;
        }).catch(ex => {
          this.loading = false;
          this.$message.error('获取人才列表出错，原因：' + ex);
        });
      },
      onSearch() {
        this.queryData.currentPage = 1;
        this.getTalentList();
        if (this.queryData.searchKey && this.queryData.searchKey.length > 0) {
          this.routeText = this.queryData.searchKey;
          this.getSplitWords();
        } else {
          this.routeText = '';
        }
      },
      onClear() {
        this.minDegree = 0,
        this.onChangeMinDegree(0);
        this.maxDegree = 0,
        this.minWorkYear = -1,
        this.onChangeMinWorkYear(-1);
        this.maxWorkYear = -1,
        this.minSalary = 0,
        this.onChangeMinSalary(0);
        this.maxSalary = 0,
        this.minAge = 0,
        this.onChangeMinAge(0);
        this.maxAge = 0,
        this.queryData.currentPage = 1;
        this.queryData.searchKey = '';
        this.queryData.resumeType = 0;

        let obj = {};
        obj.stopPropagation = () => {};
        //clear cascader city----
        try {
          if (this.$refs.casCity) {
            this.$refs.casCity.clearValue(obj);
          }
        } catch (err) {
          if (this.$refs.casCity) {
            this.$refs.casCity.handleClear(obj);
          }
        }
        //clear cascader city----
        //clear cascader position----
        try {
          if (this.$refs.casPosition) {
            this.$refs.casPosition.clearValue(obj);
          }
        } catch (err) {
          if (this.$refs.casPosition) {
            this.$refs.casPosition.handleClear(obj);
          }
        }
        //clear cascader position----

        this.queryData.city = '';
        this.cityIds = [];
        this.positionIds = [];
        this.queryData.sex = 0;
        this.queryData.resumeRefresh = 0;
        this.queryDict = [];
      },
      handleCurrentChange(index) {
        this.queryData.currentPage = index;
        this.getTalentList();
      },
      onGoto(talent) {
        let routeData = this.$router.resolve({
          path: '/TalentDetail',
          query: {
            id: talent.resumeId,
            type: talent.resumeType,
            isII: talent.isInsteadInvite,
            keyword: this.queryData.searchKey,
          }
        });
        window.open(routeData.href, '_blank');
      },
      buildQueryDict() {
        if (this.queryData.searchKey) {
          this.addQueryCondition('searchKey', this.queryData.searchKey, '关键字', this.queryData.searchKey);
        } else {
          this.removeQuery('searchKey');
        }
        if (this.queryData.resumeType) {
          this.addQueryCondition('resumeType', this.queryData.resumeType, '悬赏', this.queryData.resumeType === 1 ? '是' :
            '否');
        } else {
          this.removeQuery('resumeType');
        }
        if (this.queryData.city) {
          let cityName = this.queryData.city;
          if (this.cityId && this.queryData.city) {
            this.addQueryCondition('city', this.cityId, '意向工作地', cityName);
          }
        } else {
          this.removeQuery('city');
        }
        if (this.positionId && this.positionName) {
          this.addQueryCondition('position', this.positionId, '求职意向', this.positionName);
        } else {
          this.removeQuery('position');
        }
        if (this.minDegree) {
          let minDegree = this.minDegreeList.find(d => d.id === this.minDegree);
          let maxDegree = this.maxDegreeList.find(d => d.id === this.maxDegree);
          let text = '';
          if (this.maxDegree == 0) {
            text = `${minDegree.text}${maxDegree.text}`;
          } else {
            text = `${minDegree.text}-${maxDegree.text}`;
          }
          this.addQueryCondition('degree', `${this.minDegree}-${this.maxDegree}`, '学历要求', text);
        } else {
          this.removeQuery('degree');
        }
        if (this.minWorkYear > -1 || this.maxWorkYear > -1) {
          let minWorkYear = this.minWorkYearList.find(d => d.id === this.minWorkYear);
          let maxWorkYear = this.maxWorkYearList.find(d => d.id === this.maxWorkYear);
          let text = '';
          if (this.maxWorkYear == -1) {
            text = `${minWorkYear.text}${maxWorkYear.text}`;
          } else {
            text = `${minWorkYear.text}-${maxWorkYear.text}`;
          }
          this.addQueryCondition('workYear', `${this.minWorkYear}-${this.maxWorkYear}`, '工作年限', text);
        } else {
          this.removeQuery('workYear');
        }
        if (this.minSalary || this.maxSalary) {
          let minSalary = this.minSalaryList.find(d => d.id === this.minSalary);
          let maxSalary = this.maxSalaryList.find(d => d.id === this.maxSalary);
          let text = `${minSalary.text}-${maxSalary.text}`;
          this.addQueryCondition('salary', `${this.minSalary}-${this.maxSalary}`, '月薪范围', text);
        } else {
          this.removeQuery('salary');
        }
        if (this.minAge || this.maxAge) {
          let minAge = this.minAgeList.find(d => d.id === this.minAge);
          let maxAge = this.maxAgeList.find(d => d.id === this.maxAge);
          let text = `${minAge.text}-${maxAge.text}`;
          this.addQueryCondition('age', `${this.minSalary}-${this.maxSalary}`, '年龄', text);
        } else {
          this.removeQuery('age');
        }
        if (this.queryData.sex) {
          let sexId = this.queryData.sex;
          let sex = this.sexList.find(c => c.id === sexId);
          if (sex) {
            this.addQueryCondition('sex', sexId, '性别', sex.text);
          }
        } else {
          this.removeQuery('sex');
        }
        if (this.queryData.resumeRefresh) {
          let resumeRefreshId = this.queryData.resumeRefresh;
          let resumeRefresh = this.resumeRefreshList.find(c => c.id === resumeRefreshId);
          if (resumeRefresh) {
            this.addQueryCondition('resumeRefresh', resumeRefreshId, '简历更新时间', resumeRefresh.text);
          }
        } else {
          this.removeQuery('resumeRefresh');
        }
        if (this.queryData.industryId) {
          let industryId = this.queryData.industryId;
          let industry = this.industryList.find(c => c.id === industryId);
          if (industry) {
            this.addQueryCondition('industry', industryId, '行业', industry.text);
          }
        } else {
          this.removeQuery('industry');
        }
      },
      addQueryCondition(key, value, keyText, valueText) {
        if(valueText.length > 20){
          valueText = valueText.substr(0, 20) + '...';
        }
        var index = this.queryDict.findIndex(x => x.key === key);
        if (index < 0) {
          if (value) {
            this.queryDict.push({
              key: key,
              keyText: keyText,
              value: value,
              valueText: valueText
            });
          }
        } else {
          if (!value) {
            this.queryDict.splice(index, 1);
          } else {
            this.queryDict[index].key = key;
            this.queryDict[index].keyText = keyText;
            this.queryDict[index].value = value;
            this.queryDict[index].valueText = valueText;
          }
        }
      },
      onCloseTag(queryKey) {
        let obj = {};
        obj.stopPropagation = () => {};
        switch (queryKey) {
        case 'searchKey': {
          this.queryData.searchKey = '';
          break;
        }
        case 'resumeType': {
          this.queryData.resumeType = 0;
          break;
        }
        case 'city': {
          try {
            this.$refs.casCity.clearValue(obj);
          } catch (err) {
            this.$refs.casCity.handleClear(obj);
          }
          this.queryData.city = '';
          break;
        }
        case 'position': {
          try {
            this.$refs.casPosition.clearValue(obj);
          } catch (err) {
            this.$refs.casPosition.handleClear(obj);
          }
          this.positionIds = [];
          break;
        }
        case 'degree': {
          this.minDegree = 0;
          this.onChangeMinDegree(0);
          this.maxDegree = 0;
          break;
        }
        case 'workYear': {
          this.minWorkYear = -1;
          this.onChangeMinWorkYear(-1);
          this.maxWorkYear = -1;
          break;
        }
        case 'salary': {
          this.minSalary = 0;
          this.onChangeMinSalary(0);
          this.maxSalary = 0;
          break;
        }
        case 'age': {
          this.minAge = 0;
          this.onChangeMinAge(0);
          this.maxAge = 0;
          break;
        }
        case 'sex': {
          this.queryData.sex = 0;
          break;
        }
        case 'resumeRefresh': {
          this.queryData.resumeRefresh = 0;
          break;
        }
        case 'industry': {
          this.queryData.industryId = 0;
          break;
        }
        }
        this.onSearch();
      },
      removeQuery(queryKey) {
        var index = this.queryDict.findIndex(x => x.key === queryKey);
        if (index >= 0) {
          this.queryDict.splice(index, 1);
        }
      },
      onCityChange(city) {
        this.queryData.city = '';
        if (city && city.length == 2) {
          var cityId = city[1];
          this.cityList.forEach(c => {
            if (c.children) {
              c.children.forEach(cc => {
                if (cc.value == cityId) {
                  this.queryData.city = cc.label;
                  this.cityId = cityId;
                  return;
                }
              });
            }
          });
        }
      },
      onPositionChange(position) {
        this.queryData.position = '';
        if (position && position.length == 2) {
          var positionId = position[1];
          this.positionList.forEach(c => {
            if (c.children) {
              c.children.forEach(cc => {
                if (cc.value == positionId) {
                  this.queryData.position = cc.label;
                  this.positionId = positionId;
                  return;
                }
              });
            }
          });
        }
      },
      getSplitWords() {
        if (this.queryData.searchKey && this.queryData.searchKey.length > 0) {
          var params = {
            text: this.queryData.searchKey
          };
          getSplitWords(params).then(m => {
            if (m.errcode === 0) {
              this.keywords = m.data;
            }
          });
        }
      },
    }
  };
</script>

<style scoped>


</style>